import React from 'react';
import { connect } from 'react-redux';

import Animate from '@components/animate/Animate.tsx';
import Pages from '@components/pages/Pages.tsx';
import { addYandexMetrika, removeYandexMetrika } from '@functions/addYandexMetrika.ts';
import { StoreT } from '@global/types.ts';

import Menu from './components/menu/Menu.tsx';
import MobMenu from './components/mobMenu/MobMenu.tsx';

import handlerMenu from './methods/handlerMenu.ts';

import PublicI from './types.ts';

import pages from './static/pages.tsx';

class Public extends React.Component<PublicI['props'], PublicI['state']> implements PublicI {
    parent: PublicI['parent'];

    constructor(props: PublicI['props']) {
        super(props);
        this.state = {
            loadPages: {},
        };

        this.parent = React.createRef();
    }

    pages = pages;

    handlerMenu = handlerMenu;

    componentDidMount() {
        setTimeout(() => {
            addYandexMetrika();
        }, 1_000);
    }

    componentWillUnmount() {
        removeYandexMetrika();
    }

    render() {
        const { menuShow } = this.state;
        const { device } = this.props;

        return (
            <div ref={this.parent} className="public">
                {device === 'mobile' && (
                    <Animate className="public__mobileMenu" isShow={!!menuShow}>
                        <MobMenu handlerMenu={this.handlerMenu.bind(this)} />
                    </Animate>
                )}

                <div className="public__top">
                    <Menu handlerMenu={this.handlerMenu.bind(this)} />
                </div>

                <Pages
                    className="public__content"
                    classNamePage="JSpage public__page"
                    filter={(page) => page.parentName === 'public'}
                    pages={this.pages}
                    context={this}
                    fullHeight={true}
                />
            </div>
        );
    }
}

function mapStateToProps(state: StoreT) {
    return {
        device: state.device,
    };
}

export default connect(mapStateToProps)(Public);
